import { useParams } from 'react-router-dom';
import TownPage from './TownPage';
import { towns } from './townData';

export default function TownPageWrapper() {
  const { townSlug } = useParams();
  const town = towns.find(t => t.slug === townSlug);
  if (!town) return null;
  return <TownPage data={town} />;
}
